import * as XLSX from "xlsx";
import {KEY} from "../constant";

export default class SheetInformation {
    constructor(sheet) {
        this.keys = [];
        this.headers = [];
        this.keyColumn = 0;
        const range = sheet["!ref"];
        if (!range) return;
        const end = XLSX.utils.decode_range(range).e;
        for (let row = 0; row <= end.r; row++)
            if (row === 0) {
                for (let column = 0; column <= end.c; column++) {
                    let value = sheet[XLSX.utils.encode_cell({r: row, c: column})];
                    if (value) {
                        value = this.getCellValue(value).trim();
                        if (value === KEY) this.keyColumn = column;
                        this.headers.push(value);
                    } else this.headers.push("");
                }
            } else {
                let value = sheet[XLSX.utils.encode_cell({r: row, c: this.keyColumn})];
                this.keys.push(this.getCellValue(value).trim());
            }
    }

    getCellValue = (value) => {
        if (!value || value.t === "e") return "";
        return `${value.v || ""}`;
    };
}
